import Reveal from './Reveal';
import { guideCards } from '../content';

export default function Tutorials() {
  return (
    <section id="guides" className="scroll-mt-24 bg-[#F7F4EC] py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
            <div className="max-w-2xl">
              <p className="font-display text-xs tracking-[0.35em] text-emerald-700 uppercase">Tutorials · 操作指南</p>
              <h2 className="mt-3 text-2xl font-bold tracking-tight text-stone-900 md:text-4xl">
                使用教程：按场景查你要的操作指南
              </h2>
              <p className="mt-4 text-sm leading-7 text-stone-500 md:text-[15px]">
                每个功能都配了图文一步步拆解。想解决什么问题，直接对号入座，跟着截图就能做。
              </p>
            </div>
            <a
              href="#play"
              className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-emerald-700 transition-colors hover:text-emerald-800"
            >
              还想看进阶玩法 <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {guideCards.map((card, i) => (
            <Reveal key={card.title} delay={(i % 2) * 90}>
              <article className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-xl bg-white transition-transform duration-300 hover:-translate-y-1">
                <div className="overflow-hidden">
                  <img
                    src={card.cover}
                    alt={`${card.title} · 吃瓜软件操作指南封面`}
                    title={`吃瓜软件 · ${card.title}`}
                    className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center justify-between">
                    <span className="inline-flex rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-medium text-emerald-700">
                      {card.tag}
                    </span>
                    <span className="text-xs text-stone-400">{card.time}</span>
                  </div>
                  <h3 className="mt-3 text-base font-semibold text-stone-900 md:text-lg">{card.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-6 text-stone-500">{card.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-emerald-700 opacity-80 transition-opacity group-hover:opacity-100">
                    阅读这篇教程 <i className="ri-arrow-right-up-line text-base"></i>
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}